import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';

import { MembershipPlansSummary } from 'apps-common/components/MembershipPlansSummary';
import { useGetAccount } from 'apps-common/hooks/useGetAccount';
import { track } from 'apps-common/utils/analytics';
import { logger } from 'apps-common/utils/logger';
import { t } from 'translations';
import { Button, Header, Loader } from 'ui';
import { SuccessIcon } from 'ui/components/Icons/Success';
import { MainContainer } from 'ui/styles/containers';
import { HeaderText, Paragraph } from 'ui/styles/text';

import { routes } from '../routes';

interface UpdatePaymentMethodSuccessProps {
  renew: boolean;
}

export const UpdatePaymentMethodSuccess = (props: UpdatePaymentMethodSuccessProps) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isFetching: isFetchingAccount } = useGetAccount();
  const { account } = data ?? {};
  const { membership, b2bPartnerName = null } = account ?? {};

  useEffect(() => {
    logger.info('UpdatePaymentMethodSuccess', { props });
    track({
      event: 'Update Payment Method Success',
      payload: {
        flow: props.renew ? 'renew' : 'update_payment_method',
      },
    });
  }, [props]);

  if (isFetchingAccount) {
    return <Loader />;
  }

  return (
    <>
      <Header appType="hub" />
      <MainContainer $padding="10vh 0">
        <SuccessIcon />
        <HeaderText $textAlign="center" $fontSize="xxxlarge" $margin="12px 0">
          {props.renew ? t('membership_hub_welcome_back') : t('membership_hub_payment_method_update_success')}
        </HeaderText>
        <Paragraph $textAlign="center" $color="grayLightest" $margin="0 0 30px 0">
          {props.renew
            ? t('membership_hub_renew_notification_body')
            : t('membership_hub_payment_method_update_success_body_text')}
        </Paragraph>
        {props.renew && membership && (
          // TODO: MMBER-10607, This div is temporary until we unify all complete states to /success page.
          <div style={{ width: '45rem', maxWidth: '100%' }}>
            <MembershipPlansSummary membership={membership} b2bPartnerName={b2bPartnerName} />
          </div>
        )}
        <Button
          $margin="30px 0"
          onClick={async () => {
            await queryClient.invalidateQueries({
              queryKey: ['getAccount'],
            });
            navigate(routes.index);
          }}
        >
          {t('membership_hub_continue')}
        </Button>
      </MainContainer>
    </>
  );
};
